import React, { Component, createRef } from 'react';
import { Redirect, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {Tab,Nav} from 'react-bootstrap'; //  Col
import {format as stringFormat} from 'react-string-format';

import ModalWindow from '../commons/helpers/modalWindow';  

import {formValid} from '../../utils/validation';  
import {titleCase} from '../../utils/changeCase'; 
import {getSortClass} from '../../utils/commonUtilities'; 
import {userGroupUrlCheck} from '../../utils/userGroupUrlCheck';

import {rolesListAction, rolesAddAction,  rolesUpdateAction, rolesDeleteAction, rolesPermissionEditAction, rolesPermissionUpdateAction} from '../../actions/rolesPermissionsAction';  // rolesEditAction
import {clearAction} from '../../actions/commonActions';
import Toast from '../commons/helpers/toast';

import {LBL_APP_NAME, LBL_SETTINGS, LBL_ROLE, LBL_ROLES, LBL_PERMISSIONS, LBL_ACTIONS, LBL_SLNUM, LBL_ROLES_AND_PERMISSIONS,LBL_FULL_ACCESS,LBL_ARE_YOU_SURE_DELETE_COMMON,LBL_DELETE,LBL_SET_PERMISSIONS,LBL_VIEW,LBL_MODIFY,LBL_CONFIRM_DELETE} from '../../configs/labelConfigs';  
import {URL_IMG} from '../../configs/urlConfigs';
import {MSG_ROLES_REQUIRED, MSG_ROLES_ADD_SUCCESS, MSG_ROLES_UPDATE_SUCCESS, MSG_ROLES_DELETE_SUCCESS, MSG_ROLES_PERMISSION_SUCCESS, MSG_ROLES_ADD_EDIT_DUPLICATE} from '../../configs/msgConfigs'; 
import {ROUTE_REFRESH,ROUTE_AFFILIATE_REFRESH,LIST_TYPE, ADD_TYPE, EDIT_TYPE, UPDATE_TYPE,DELETE_TYPE,LOGIN_AFFILIATE_GROUP} from '../../configs/staticConfigs';


class RolesPermissionComponent extends Component { 
    
    constructor(props){
        super(props)

        this.state = {
            rolesList: [],
            permissionsList: [],
            permissionsEditListCol1: [],
            permissionsEditListCol2: [],
            permissionsEditFullList: [],
            pEditRowsCol1: 0,
            pEditRowsCol2: 0, 
            rolesListStatus: 0,
            rolesStatusText: '', 
            dropdownExpanded: false,
            activeRowId:0,            
            formErrors:{
                roleName: ''            
            },   
            rolesData:{
                roleId: 0,
                roleName: '',
                rolePermissions: []
            },
            editMode:false,
            sortField: 'id',
            sortOrder: '',
            toastMessage:'',
            toastFlag:false,
            toastSuccess:true,
            deleteFieldName: '', 
            modalOpened: '',
            editRoleId: 0, 
            editRoleName: '', 
            editPermissions: [], 
            pageLoaded: 0,
            roleNameFormError: '',  
        }

        this.openModal = this.openModal.bind(this);
        this.onSaveFormData = this.onSaveFormData.bind(this);
        this.onSavePermissionData = this.onSavePermissionData.bind(this); 
        this.onModalFormReset = this.onModalFormReset.bind(this);
        this.onShowActionButtons = this.onShowActionButtons.bind(this);
        this.onHideActionButtons = this.onHideActionButtons.bind(this);
        this.onHandleChange = this.onHandleChange.bind(this);
        this.onSort = this.onSort.bind(this);
        this.setModalOpened = this.setModalOpened.bind(this); 
        this.handleChangeCheckbox = this.handleChangeCheckbox.bind(this); 
        this.openPermissionModal = this.openPermissionModal.bind(this); 
        this.modalDelete = React.createRef();
        this.modal = React.createRef();
        this.modalPermission = React.createRef();
    }

    componentDidMount() {
        let userGroupData = userGroupUrlCheck(this.props.location);
        let userGroup = ''; 
        if(userGroupData!==undefined){
            userGroup = userGroupData.user_group; 
        }
        if(userGroup===LOGIN_AFFILIATE_GROUP){
            document.body.classList.add('body-affiliate'); 
        }  
        document.title = LBL_APP_NAME+" - "+LBL_SETTINGS+" - "+LBL_ROLES_AND_PERMISSIONS;
        this.props.rolesListAction();   
    }

    onSort = (sortKey) =>{    
        let sOrder = '';
        let tmpObj = [...this.state.rolesList];
        if(this.state.sortField===sortKey){         
            if(this.state.sortOrder==='' || this.state.sortOrder==='desc') {
                sOrder = 'asc';
                tmpObj.sort((a,b) => a.name.localeCompare(b.name));
            }
            else if(this.state.sortOrder==='asc') {
                sOrder = 'desc';
                tmpObj.sort((a,b) => b.name.localeCompare(a.name));
            }
            this.setState({ rolesList:tmpObj, sortField:sortKey, sortOrder:sOrder });            
        }else{
            sOrder = 'asc';
            tmpObj.sort((a,b) => a.name.localeCompare(b.name));
            this.setState({ rolesList:tmpObj, sortField:sortKey, sortOrder:sOrder });          
        }        
    }

    onHandleChange = (event) =>{        
        const {name, value} = event.target;
        let roleNameFormError = this.state.roleNameFormError;
        switch(name){
            case 'roleName':
                roleNameFormError = value.trim().length <=0 ? MSG_ROLES_REQUIRED : ""; 
                break;       
            case 'selPermissions':
                // this.setState({editRoleId:0, editRoleName:'', editPermissions:[]});
                let listObj = value.split('~~'); // this.props.rolesList; 
                let tmpEId = parseInt(listObj[0],10); 
                let tmpEName = listObj[1]; 
                let tmpEPerm = []; 
                listObj[2].split(',').map( (pid) => (parseInt(pid,10)) && tmpEPerm.push(parseInt(pid,10))); 
                this.setState({editRoleId:tmpEId, editRoleName:tmpEName, editPermissions:tmpEPerm}); 
                break;      
                         
            default : break;
        }
        let rolesData   = this.state.rolesData;
        rolesData.roleName = value;
        this.setState({roleNameFormError,rolesData});
    } 

    onSavePermissionData = (roleId) => { 
        this.setState({toastAction:true});                      
        if(roleId){
            let rolesData= {
                id: this.state.editRoleId, 
                name: this.state.editRoleName,   
                permissions: this.state.editPermissions      
            } 
            // console.log('SavePermission '+JSON.stringify(rolesData)); 
            this.props.rolesPermissionUpdateAction(rolesData); 
        }else{
            
        }    
        this.onModalFormReset(); 
        this.modalPermission.current.handleModelClose(); 
    }

    onSaveFormData = (editRoleId) =>{
        if(formValid(this.state)){
            this.setState({toastAction:true});      
            let rName = this.state.rolesData.roleName.trim();                 
            if(editRoleId){
                if(rName==='') {
                    this.setState({roleNameFormError:MSG_ROLES_REQUIRED});
                }
                else {
                    let foundRole = 0; 
                    this.state.rolesList.map((rObj) => {
                        if(editRoleId!==rObj.id && rObj.name===rName.toLowerCase()) {
                            foundRole = 1; 
                        }
                        return console.log('found'); 
                    }); 
                    if(foundRole > 0) {
                        this.setState({roleNameFormError:MSG_ROLES_ADD_EDIT_DUPLICATE});
                    }
                    else {
                        let rolesData= {
                            id:editRoleId,
                            name: this.state.rolesData.roleName.trim(),   
                            permissions: this.state.rolesData.rolePermissions                
                        } 
                        this.props.rolesUpdateAction(rolesData); 
                        this.onModalFormReset();
                        this.modal.current.handleModelClose();
                    }
                }
            }else{
                if(rName==='') {
                    this.setState({roleNameFormError:MSG_ROLES_REQUIRED});
                }
                else {
                    let foundRole = 0; 
                    this.state.rolesList.map((rObj) => {
                        if(rObj.name===rName.toLowerCase()) {
                            foundRole = 1; 
                        } 
                        return console.log('found'); 
                    }) 
                    if(foundRole > 0) {
                        this.setState({roleNameFormError:MSG_ROLES_ADD_EDIT_DUPLICATE});
                    }
                    else {
                        let rolesData= {
                            name: this.state.rolesData.roleName,                      
                        } 
                        this.props.rolesAddAction(rolesData); 
                        this.onModalFormReset();
                        this.modal.current.handleModelClose();
                    }
                }                
            }    
        }else{
            let roleNameFormError = this.state.roleNameFormError;
            if(this.state.rolesData.roleName===''){
                roleNameFormError = MSG_ROLES_REQUIRED; 
            }            
            this.setState({roleNameFormError});
        }
    }

    setModalOpened(modalType) {
        // console.log(modalType); 
        this.setState({modalOpened:modalType}); 
    }

    handleChangeCheckbox(colNum,pId,e) {
        // let tmpListObj = this.state.rolesList; 
        let tmpEditPerm = this.state.editPermissions; 
        // console.log('tmpEditPerm: '+tmpEditPerm); 
        if(e.target.checked && tmpEditPerm.indexOf(pId) < 0) tmpEditPerm.push(pId); 
        else tmpEditPerm = tmpEditPerm.filter(item => item !== pId); 
        this.setState({editPermissions:tmpEditPerm}, () => {
            // console.log('ChangCHk: EditRoleId: '+this.state.editRoleId+', editRoleName: '+this.state.editRoleName+' editPermissions: '+JSON.stringify(this.state.editPermissions)); 
        }); 
        // this.setState({rolesList:tmpListObj}); 
    }

    openModal(e) {  
        switch(e.target.dataset.toggle){
            case 'modal':   this.setState({modalOpened:'roleModal'}); 
                            this.modal.current.handleOpenModal(); 
                            break; 
            case 'modalPermission': 
                            let tmpObj = {id:0, name:'', permissions:[]};
                            this.openPermissionModal(tmpObj);  
                            break; 
            default: return;
        }
    }  

    openPermissionModal(roleObj) {
        this.setState({editRoleId:roleObj.id}); 
        console.log('openPermissionModal: '+JSON.stringify(roleObj)); 
        let editListCol1 = []; 
        let editListCol2 = []; 
        let tmpEditObj = {}; 
        let pNamesObj = [...new Set(this.state.permissionsList.map(item => item.name))];
        let copyObj = this.state.permissionsList;  
        let totRows = pNamesObj.length; 
        let col1 = (totRows%2) ? ((totRows/2)+1) : (totRows/2); 
        let col2 = totRows-col1; 
        let tmpRowCnt = 0; 

        pNamesObj.map(function(item) {
            tmpRowCnt++; 
            tmpEditObj = {
                pName: item,
                viewId: 0,
                viewCode: '',
                viewChecked: false,
                modifyId: 0,
                modifyCode: '',
                modifyChecked: false
            }; 
            copyObj.filter(pItem => pItem.name.includes(item)).map(function(eachItem) {
                let arrCode = eachItem.codename.split('_'); 
                if(arrCode[3]==='view') {
                    tmpEditObj.viewId = eachItem.id;
                    tmpEditObj.viewCode = eachItem.codename;
                }
                else if(arrCode[3]==='modify') {
                    tmpEditObj.modifyId = eachItem.id;
                    tmpEditObj.modifyCode = eachItem.codename; 
                }
                return console.log('mp'); 
            })          
            if(tmpRowCnt<=col1) editListCol1.push(tmpEditObj); 
            else editListCol2.push(tmpEditObj); 
            return console.log('mp'); 
        });
        // console.log('tmpEditList: '+JSON.stringify(editListCol1)); 
        let tmpId = roleObj.id; // this.state.rolesList[0].id; 
        let tmpName = roleObj.name; // this.state.rolesList[0].name; 
        let tmpPerm = roleObj.permissions; // this.state.rolesList[0].permissions; 
        
        // console.log('editRoleId22: '+tmpId+', editRoleName:'+tmpName+', editPermissions'+JSON.stringify(tmpPerm));

        this.setState({editRoleId:tmpId, editRoleName:tmpName, editPermissions:tmpPerm, permissionsEditListCol1:editListCol1, permissionsEditListCol2:editListCol2, pEditRowsCol1:col1, pEditRowsCol2:col2, modalOpened:'roleModal'}, () => {
            this.modalPermission.current.handleOpenModal();
            // console.log('EditRoleOpen: EditRoleId: '+this.state.editRoleId+', editRoleName: '+this.state.editRoleName+' editPermissions: '+JSON.stringify(this.state.editPermissions)); 
        });
    }

    onModalFormReset = () =>{   
        let rolesDet   = this.state.rolesData;     
        rolesDet.roleId = 0;
        rolesDet.roleName = '';  
        rolesDet.rolePermissions = [];        
        this.setState({roleNameFormError:'', rolesData:rolesDet, editRoleId:0, editRoleName:'', editPermissions:[], deleteFieldName: ''}); 
        this.props.clearAction();  
    }

    onShowActionButtons = (event, rowId) =>{
        let dropdown     = document.getElementById('dropdown-'+rowId);
        let dropdownMenu = document.getElementById('dropdown-menu-'+rowId);
        dropdown.classList.toggle('show');
        dropdownMenu.classList.toggle('show');      

        if(this.state.activeRowId===0){   
            this.setState({activeRowId:rowId}); 
            document.getElementById('img-action-'+rowId).focus();
        }
        else if(this.state.activeRowId===rowId){ 
            this.setState({activeRowId:0}); 
        }
        else if(this.state.activeRowId!==rowId){   
            dropdown     = document.getElementById('dropdown-'+this.state.activeRowId);
            dropdownMenu = document.getElementById('dropdown-menu-'+this.state.activeRowId);
            dropdown.classList.toggle('show');
            dropdownMenu.classList.toggle('show');
            this.setState({activeRowId:rowId}); 
            document.getElementById('img-action-'+rowId).focus();
        }        
    } 

    onHideActionButtons = (event, rowId) =>{
        let dropdown     = document.getElementById('dropdown-'+rowId);
        let dropdownMenu = document.getElementById('dropdown-menu-'+rowId);
        dropdown.classList.remove('show');
        dropdownMenu.classList.remove('show');
        this.setState({activeRowId:0});
    }

    onCloseToast = () =>{
        this.setState({toastFlag:false,toastMessage:''});
    }  

    editBtnClick = (item) =>{  
        let roleNameFormError = this.state.roleNameFormError;
        roleNameFormError = '';
        let roleDet = this.state.rolesData;
        roleDet.roleId = item.id;
        roleDet.roleName = titleCase(item.name);
        roleDet.rolePermissions = item.permissions;
        this.setState({roleNameFormError:roleNameFormError,rolesData:roleDet,editRoleId:item.id});
        // console.log('rolesData: '+JSON.stringify(this.state.rolesData)); 
        this.modal.current.handleOpenModal();
        // this.props.sectorEditAction(rowId);
    }

    deleteBtnClick = (rowId,itemName) =>{
        console.log('rowId: '+rowId+', itemName: '+itemName); 
        this.setState({
            rolesData: {
                roleId: rowId
            }, deleteFieldName: itemName
        }, () => { this.modalDelete.current.handleOpenModal() }); 
    }

    onDeleteAction = () =>{
        let roleId = this.state.rolesData.roleId;
        this.props.rolesDeleteAction(roleId); 
        this.modalDelete.current.handleModelClose();              
    }

    componentDidUpdate(prevProps) {       
        // MSG_ROLES_PERMISSION_SUCCESS 
        // console.log('this.props: '+this.props.activity); 
        if(this.props.status===401 || this.props.status===403){
            return <Redirect to={ROUTE_REFRESH} />;
        }

        if (this.state.pageLoaded===0 || this.props.activity !== prevProps.activity || this.props.status !== prevProps.status) {
            if(this.props.activity===LIST_TYPE){
                console.log('permissionsList: '+JSON.stringify(this.props.permissionsList)); 
                this.setState({pageLoaded:1,rolesList:this.props.rolesList, permissionsList:this.props.permissionsList}, () => {
                    if(this.state.sortField==='id' && this.state.sortOrder==='') this.onSort('name'); 
                     });
            } else if(this.props.activity===ADD_TYPE){
                this.props.rolesListAction();
                this.setState({pageLoaded:1,toastFlag:true,toastMessage:MSG_ROLES_ADD_SUCCESS});
                setTimeout(()=> {
                    this.onCloseToast();
                }, 3000);
            }else if(this.props.activity===EDIT_TYPE){
                this.props.rolesListAction();
                this.setState({pageLoaded:1,toastFlag:true,toastMessage:MSG_ROLES_UPDATE_SUCCESS});
                setTimeout(()=> {
                    this.onCloseToast();
                }, 3000);          
            }else if(this.props.activity===DELETE_TYPE){
                this.props.rolesListAction();
                this.setState({pageLoaded:1,toastFlag:true,toastMessage:MSG_ROLES_DELETE_SUCCESS});
                setTimeout(()=> {
                    this.onCloseToast();
                }, 3000);
            }else if(this.props.activity===UPDATE_TYPE){
                this.props.rolesListAction();
                this.setState({pageLoaded:1,toastFlag:true,toastMessage:MSG_ROLES_PERMISSION_SUCCESS});
                setTimeout(()=> {
                    this.onCloseToast();
                }, 3000);          
            }else{
                // console.log('error');    
            }
        }
    }

    render(){
        const {
            toastMessage,toastFlag,toastSuccess,sortField,sortOrder,              
        } = this.state

        // const { rolesList,role} = this.props;    
        // console.log('this.props.status: '+this.props.status);
        const { status} = this.props;  
        
        let userGroupData = userGroupUrlCheck(this.props.location);
        let userGroup = ''; 
        if(userGroupData!==undefined){
            userGroup = userGroupData.user_group; 
        }

        if(status===401 || status===403){
            if(userGroup===LOGIN_AFFILIATE_GROUP){
                return <Redirect to={ROUTE_AFFILIATE_REFRESH} />;
            }else{
                return <Redirect to={ROUTE_REFRESH} />;

            }
        }

        let chkCnt = 0; 
        let chkField = ''; 
        let chkField22 = ''; 

        return(
            <div className="col-md-8">
                <Toast toastDescription={toastMessage} toastFlag={toastFlag} toastSuccess={toastSuccess} closeToast={this.onCloseToast} />
                <div className="box">
                    <div className="box-head">
                        <div className="to-right">             
                            <button className="btn btn-primary launch-modal" onClick={this.openModal.bind(this)} data-target="#addNew-role" data-toggle="modal">Add {LBL_ROLE}</button>
                            <button className="btn btn-primary launch-modal" onClick={this.openModal.bind(this)} data-target="#addNew-permissions" data-toggle="modalPermission">Set {LBL_PERMISSIONS}</button> 
                            {/* <button className="btn btn-primary launch-modal" onClick={this.openModal.bind(this)} data-target="#addNew-permissions" data-toggle="modalPermission">Set {LBL_PERMISSIONS}</button> */}
                        </div>
                    </div> 
                    <div className="box-content">
                        <div className="table-responsive">
                            <table id="data-table" className="table" style={{width:"100%"}}>
                                <thead>
                                    <tr>
                                    <th className="text-center">{LBL_SLNUM}</th>
                                    <th onClick={(e) => this.onSort('name')} className="spanPointer">{LBL_ROLES} <i className={sortField=='name' ? getSortClass(1,sortOrder) : getSortClass()}></i></th>
                                    <th>{LBL_ACTIONS}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    { (this.state.rolesList) && this.state.rolesList.map((item,itemIndex) => {
                                    if(item.name.toLowerCase().trim()==='admin') { 
                                        return (<tr key={item.id}>
                                            <td className="text-center">{itemIndex+1}</td>
                                            <td>{titleCase(item.name)} ({LBL_FULL_ACCESS})</td>
                                            <td></td>
                                        </tr>)
                                    }
                                    else {
                                        return (
                                            <tr key={item.id}>
                                                <td className="text-center">{itemIndex+1}</td>
                                                <td>{titleCase(item.name)}</td>
                                                <td>
                                                    <div className="dropdown" id={'dropdown-'+item.id}>
                                                        <button className="dropdown-toggle" type="button"
                                                            id={'dropdownMenuButton-'+item.id} data-toggle="dropdown" aria-haspopup="true" aria-expanded={this.state.dropdownExpanded} onClick={(e) => this.onShowActionButtons(e, item.id)}
                                                            >
                                                            <input type="image" id={"img-action-"+item.id} src={require('../../'+URL_IMG+'action.png')} alt="Action" onBlur={(e) => this.onHideActionButtons(e, item.id)} ></input>
                                                        </button>
                                                        <div className="dropdown-menu" id={'dropdown-menu-'+item.id} aria-labelledby="dropdownMenuButton">
                                                            <Link className="dropdown-item edit" to="#" onMouseDown={(e) => this.editBtnClick(item)}>Edit</Link>  
                                                            <Link className="dropdown-item edit" to="#" onMouseDown={(e) => this.openPermissionModal(item)}>{LBL_SET_PERMISSIONS}</Link>
                                                            <Link className="dropdown-item delete"
                                                                to="#" onMouseDown={(e)=>this.deleteBtnClick(item.id,(LBL_ROLE+' "'+titleCase(item.name)+'"'))}>{LBL_DELETE}</Link>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        )
                                    }
                                })} 
                                </tbody>
                            </table>
                            <div>&nbsp;</div>
                            <div>&nbsp;</div>
                            <div>&nbsp;</div>
                            <div>&nbsp;</div>
                        </div>
                    </div>
                </div>
                
                <ModalWindow ref={this.modalDelete} header={LBL_CONFIRM_DELETE} type="delete" deleteItem={this.onDeleteAction} resetModalForm={this.onModalFormReset} >
                 {stringFormat(LBL_ARE_YOU_SURE_DELETE_COMMON,this.state.deleteFieldName)} 
                </ModalWindow>

                <ModalWindow ref={this.modal} header={"User Role"} modalId={"addNew-role"}  saveFormData={ (e)=>this.onSaveFormData(this.state.editRoleId)} resetModalForm={this.onModalFormReset} type="save"  >
                    <div className="row">
                            <div className="col-md-12">
                                <div className="form-group">
                                    <label>{LBL_ROLE}</label>
                                    <div className="text-input">
                                    <input type="text" name="roleName"  onChange={this.onHandleChange} placeholder="" value={this.state.rolesData.roleName} maxLength={120} />
                                    {this.state.roleNameFormError.length >0 && (
                                        <div className="text-red left-align text-12">{this.state.roleNameFormError}</div>
                                    )} 
                                    </div>
                                </div>
                            </div>
                    </div>
                </ModalWindow>

                {/* editRoleId, editRoleName, editPermissions */}
                <ModalWindow ref={this.modalPermission} header={"User Role & Module Permissions"} modalId={"addNew-permissions"} saveFormData={ (e)=>this.onSavePermissionData(this.state.editRoleId)} resetModalForm={this.onModalFormReset} type="save" >
                    <div className="row">
                    <Tab.Container id="dynamicField-tab" defaultActiveKey="dynamicField-details-tab">
                        <div className="col-3">
                            <div className="box">
                                <div className="tab-head"></div>
                                <div className="text-bold normalText leftPanelHeading">{LBL_ROLES}</div>
                                <hr />
                            </div>

                            {/* onClick={ (e) => this.state.activePageId!==item.id ? this.changePage(e, item.id) : '' }             */}
                            <Nav variant="pills" className="nav flex-column nav-pills box">
                            {this.state.rolesList.map((item) => (item.name.toLowerCase().trim()!=='admin') &&<Nav.Link key={item.id}  className={this.state.activePageId===item.id ? "text-bold" : ''} > {item.name}</Nav.Link>
                                    )
                                } 
                            </Nav>
                        </div>
                        <div className="col-9">
                            {/* <div className="row">
                                <div className="col-12">
                                    <div className="form-group">
                                        <label>Role</label>
                                        <div className="form-group select-input">
                                            <select name="selPermissions" onChange={this.onHandleChange} defaultValue={this.state.editRoleId+'~~'+this.state.editRoleName+'~~'+this.state.editPermissions}>
                                                <option key="sel0" value={('0~~~~')}>Select {LBL_ROLE}</option>
                                                {this.state.rolesList.map((item) => (item.name.toLowerCase().trim()!=='admin') && <option key={item.id} value={(item.id+'~~'+item.name+'~~'+item.permissions)}>{titleCase(item.name)}</option>)}                                     
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div> */}

                            {/* this.state..data.length) && (pEditRowsCol1) , , pEditRowsCol2 */}
                                     
                            <div className="row">
                                    <div className="box col-12">
                                        <div className="tab-head"></div>
                                        <div className="text-bold normalText leftPanelHeading">{LBL_PERMISSIONS}</div><hr />
                                        
                                    </div>
                                <div className="col-6">
                                    <div className="row">
                                        <div className="col-6"></div>
                                        <div className="col-6">
                                            <div className="row">
                                                <div className="col-6 text-center"><label>{LBL_VIEW}</label></div>
                                                <div className="col-6 text-center"><label>{LBL_MODIFY}</label></div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* "pName":"associate users","viewId":142,"viewCode":"omnu_superadmin_associateusers_view","viewChecked":0,"modifyId":0,"modifyCode":"","modifyChecked":0 */}
                                    
                                    { this.state.permissionsEditListCol1.map((item) => {
                                        chkCnt++; chkField   = 'chk_'+chkCnt; 
                                        chkCnt++; chkField22 = 'chk_'+chkCnt; 
                                        return <div className="row" key={item.pName}>
                                        <div className="col-6"><label>{titleCase(item.pName)}</label> </div>
                                        <div className="col-6">
                                            <div className="row">
                                                {/* this.state.rolesData. editRoleId, editRoleName, editPermissions */}
                                                
                                                <div className="custom-checkbox col-6 text-center">
                                                {item.viewId > 0 && <input type="checkbox" id={chkField} checked={this.state.editPermissions.indexOf(item.viewId) >= 0 ? true : false} onChange={(event) => this.handleChangeCheckbox('col1',item.viewId,event)} /> } <label className="checkbox" htmlFor={chkField.toString()}></label></div>
                                                  
                                                <div className="custom-checkbox col-6 text-center">
                                                { item.modifyId > 0 && <input type="checkbox" id={chkField22} checked={this.state.editPermissions.indexOf(item.modifyId) >= 0 ? true : false} onChange={(event) => this.handleChangeCheckbox('col1',item.modifyId,event)} />} <label className="checkbox" htmlFor={chkField22.toString()}></label>
                                                 
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    } ) }
                                </div>
                                

                                <div className="col-6">
                                    <div className="row">
                                        <div className="col-6"></div>
                                        <div className="col-6">
                                            <div className="row">
                                                <div className="col-6 text-center"><label>{LBL_VIEW}</label></div>
                                                <div className="col-6 text-center"><label>{LBL_MODIFY}</label></div>
                                            </div>
                                        </div>
                                    </div>
                                    { this.state.permissionsEditListCol2.map((item) => {
                                        chkCnt++; chkField = 'chk_'+chkCnt; 
                                        chkCnt++; chkField22 = 'chk_'+chkCnt; 
                                        return <div className="row" key={item.pName}>
                                        <div className="col-6"><label>{titleCase(item.pName)}</label></div>
                                        <div className="col-6">
                                            <div className="row">
                                                
                                                <div className="custom-checkbox col-6 text-center">{item.viewId > 0 && <input type="checkbox" id={chkField} checked={this.state.editPermissions.indexOf(item.viewId) >= 0 ? true : false} onChange={(event) => this.handleChangeCheckbox('col2',item.viewId,event)} /> } <label className="checkbox" htmlFor={chkField.toString()}></label></div>

                                                
                                                <div className="custom-checkbox col-6 text-center">{ item.modifyId > 0 && <input type="checkbox" id={chkField22} checked={this.state.editPermissions.indexOf(item.modifyId) >= 0 ? true : false}  onChange={(event) => this.handleChangeCheckbox('col2',item.modifyId,event)} /> } <label className="checkbox" htmlFor={chkField22.toString()}></label></div>
                                            </div>
                                        </div>   
                                    </div>
                                     } ) }
                                    
                                </div>
                            </div>
                        </div>
                        </Tab.Container>    
                    </div>

                </ModalWindow>

            </div>
        )
        
    }
    
}


const mapStateToProps = (response) => {
    console.log('mapStateToProps: '+JSON.stringify(response.rolesPermission)); // VALUES FROM REDUCER 
    // this.state.rolesList = response.rolesPermission.rolesList;
    // console.log('mapStateToProps: '+JSON.stringify(response.rolesPermission.rolesList));
    return {
        rolesList: response.rolesPermission.rolesList,  
        permissionsList: response.rolesPermission.permissionsList,  
        status: response.rolesPermission.status,
        rolesStatusText: response.rolesPermission.statusText,
        activity: response.rolesPermission.activity
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        rolesListAction:data=>rolesListAction(data), 
        rolesAddAction:data=>rolesAddAction(data),
        //rolesEditAction:id=>rolesEditAction(id),
        rolesUpdateAction:data=>rolesUpdateAction(data),
        rolesDeleteAction:id=>rolesDeleteAction(id), 
        rolesPermissionEditAction:id=>rolesPermissionEditAction(id),
        rolesPermissionUpdateAction:data=>rolesPermissionUpdateAction(data),
        clearAction:clearAction
    },dispatch);  
}
export default connect(mapStateToProps,mapDispatchToProps)(RolesPermissionComponent);
